'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgHoc = require('../svgHoc');

var _svgHoc2 = _interopRequireDefault(_svgHoc);

var _migLogo = require('../svg/mig-logo.svg');

var _migLogo2 = _interopRequireDefault(_migLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _svgHoc2.default)(_migLogo2.default);